<template>
  <base-modal
    hide-footer
    :closeable-from-outside="false"
    :size="'sm'"
    :modal-id="'copy-link-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <template #modal-header>
      <div class="head-label d-flex align-item-center">
        <icon-copy-link class="icon-copy-link mr-2" /> <span>Copy Link</span>
      </div>
    </template>
    <b-row>
      <b-col class="mt-1">
        <div class="d-flex justify-content-between">
          <div class="link-input-wrp d-flex align-item-center">
            <div id="linkUrl">
              {{
                urlLink ||
                  "https://chococrm.com/dod8fisjjf73elkwoprddod8fisjjf73elkwoprdklkl73elkwoprddod8fisjjf73elk"
              }}
            </div>
          </div>
          <div>
            <b-button class="btn-copy-link ml-2" @click="copylink">
              <div class="d-flex align-items-center justify-content-center">
                <span>{{ "Copy Link" }}</span>
              </div>
            </b-button>
            <div class="mt-1 icon-area">
              <div
                class="d-flex justify-content-center align-item-center"
                id="showSuccess"
              >
                <div class="icon-check-wrp d-flex align-item-center">
                  <icon-check />
                </div>
                <div class="ml-1 text-copy-success">คัดลอกแล้ว</div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex justify-content-center mb-1 mt-1">
          <b-button
            class="btn-code-copy-link ml-2"
            @click="$emit('onCloseModal')"
          >
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ "ปิด" }}</span>
            </div>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import IconCopyLink from "@/@core/components/svg/action-group/IconCopyLink.vue";
import IconCheck from "@/@core/components/svg/common/IconCheck.vue";

export default {
  components: { BaseModal, IconCopyLink, IconCheck },
  props: { urlLink: null },
  setup() {
    const copylink = () => {
      var urlToCopy = document.querySelector("#linkUrl").textContent;
      navigator.clipboard.writeText(urlToCopy);

      var showTextSuccess = document.getElementById("showSuccess");
      showTextSuccess.className = "show";
      setTimeout(function() {
        showTextSuccess.className = showTextSuccess.className.replace(
          "show",
          ""
        );
      }, 1000);
    };

    return {
      copylink,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/modal-copy-link.css";
</style>
